import React from 'react';

// Match http(s) URLs and bare www. URLs. Keeps trailing punctuation out of the link.
const URL_REGEX = /(\b(?:https?:\/\/|www\.)[^\s<>()"]+[^\s<>()"\.,;:!?])/gi;

/**
 * Renders a string with URLs converted to clickable anchor tags.
 * Newlines are preserved (the parent should still apply `whitespace-pre-wrap`).
 */
export function linkify(text: string): React.ReactNode[] {
  if (!text) return [];
  const parts = text.split(URL_REGEX);
  return parts.map((part, i) => {
    if (URL_REGEX.test(part)) {
      // Reset lastIndex (regex with /g is stateful)
      URL_REGEX.lastIndex = 0;
      const href = part.startsWith('http') ? part : `https://${part}`;
      return (
        <a
          key={i}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="underline underline-offset-2 break-all hover:opacity-80"
        >
          {part}
        </a>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}